// Firebase configuration and initialization
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBC_Dmq2INImkkSzFd5kokHWJXs9U9BLjM",
  authDomain: "ezypipe.firebaseapp.com",
  projectId: "ezypipe",
  storageBucket: "ezypipe.firebasestorage.app",
  messagingSenderId: "713029840293",
  appId: "1:713029840293:web:af1709d5186f29e5800c4c",
  measurementId: "G-GBGK0HB3JX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, 'us-central1');

// Initialize Analytics only in production
let analytics = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'production') {
  analytics = getAnalytics(app);
}

// Google Auth Provider for Sign-In
export const googleProvider = new GoogleAuthProvider();

export { analytics };
export default app;

// DEV ONLY: Expose Firebase to window for console scripts
if (typeof window !== 'undefined') {
  window.firebaseDb = db;
  window.firebaseAuth = auth;
  console.log('[Firebase] Exposed to window:', { auth: !!auth, db: !!db });
}
